import React from 'react';
import { Button } from './ui/Button';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-gradient-to-br from-[#E5B3E5] via-[#F5E6F5] to-white py-24 overflow-hidden" data-id="element-293">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
        <div className="flex flex-col lg:flex-row items-center" data-id="element-295">
          <div className="w-full lg:w-1/2 mb-12 lg:mb-0" data-id="element-296">
            <div className="bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-md mb-8 border-2 border-[#9333EA]" data-id="element-297">
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-298">
                Turn your attendees into{' '}
                <span className="text-[#9333EA]" data-id="element-299">active participants</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8 max-w-lg" data-id="element-300">
                Nexio App helps event organizers collect questions, manage
                speaker submissions, and gather community input — creating
                conferences that truly engage.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-301">
              <Button size="lg" className="min-w-[180px] shadow-md" href="https://nexioapp.eu/dashboard/register" data-id="element-302">
                Start for free
              </Button>
              <Button variant="outline" size="lg" className="min-w-[180px]" href="https://calendar.app.google/6fKsGXEmBQzjPvnc9" data-id="element-303">
                Plan a Demo
                <ArrowRightIcon className="ml-2" size={16} data-id="element-304" />
              </Button>
            </div>
          </div>
          <div className="w-full lg:w-1/2" data-id="element-305">
            <div className="relative" data-id="element-306">
              <div className="bg-white rounded-xl shadow-xl p-4 transform transition-transform hover:scale-[1.02] duration-300 border-2 border-[#9333EA]" data-id="element-307">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1curTRZVzRzHPzRKqGu1uj/Schermafbeelding_2025-08-30_140602.png" alt="Event management dashboard" className="rounded-lg w-full shadow-sm" data-id="element-308" />
                <div className="absolute -bottom-6 -left-6 bg-white rounded-lg shadow-lg p-4 w-48 border border-[#9333EA] transform transition-transform hover:scale-105 duration-300" data-id="element-309">
                  <div className="flex items-center space-x-2 mb-2" data-id="element-310">
                    <div className="w-2 h-2 rounded-full bg-[#E5B3E5]" data-id="element-311"></div>
                    <span className="text-sm font-medium" data-id="element-312">
                      New question submitted
                    </span>
                  </div>
                  <p className="text-xs text-gray-500" data-id="element-313">
                    From audience to panel in seconds
                  </p>
                </div>
                <div className="absolute -top-6 -right-6 bg-white rounded-lg shadow-lg p-4 w-48 border border-[#9333EA] transform transition-transform hover:scale-105 duration-300" data-id="element-314">
                  <div className="flex items-center space-x-2 mb-2" data-id="element-315">
                    <div className="w-2 h-2 rounded-full bg-[#9333EA]" data-id="element-316"></div>
                    <span className="text-sm font-medium" data-id="element-317">
                      47 speaker proposals
                    </span>
                  </div>
                  <p className="text-xs text-gray-500" data-id="element-318">
                    Organized and ready to review
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}